<template lang="pug">
  .component-client-reservations
    .action-bar
      .title
        h2 Client Reservations
      .action
        reservation-list-form(:type="'entity-filter'", @filterReservations="filterReservations")
        i.fa.fa-plus-circle.fa-2x(data-toggle="create-reservation")

    .tabs-inner-content.no-horizontal-space.client-reservations.fill-bg
      #create-reservation.is-hidden(data-toggler="is-hidden", v-f="")
        book-panel(v-if="drivers.length > 0 ", :entityDrivers="drivers", @reservationCreated="$refs.loader.loadData(1)")
      base-list(ref="loader", :component="component", :search="search", :dataLoader="dataLoader")

</template>
<script type="text/babel">
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
  import ReservationListForm from "components/structure/ui/filters/ReservationListForm";
  import BookPanel from "components/structure/ui/BookPanel";
  import BaseList from "../../../pages/backoffice/BaseList";

  export default {
    name: "ClientReservations",
    components: {
      BaseList,
      BookPanel,
      ReservationListForm,
    },
    data() {
      return {
        component: require('components/backoffice/Reservation'),
        reservations: [],
        search: {
          client_id: this.$route.params.id
        },
        drivers: [],
      }
    },
    created() {
      this.loadDrivers()


    },
    methods: {
      dataLoader(callback, page, resultsPerPage) {
        KeplerBackofficeSdk.reservations.list(page, resultsPerPage, this.search).all((data) => {
          callback(data)
        })
      },
      filterReservations(body) {
        this.$set(this.search, 'status', body.status)

        if (this.search.status === '') {
          delete this.search.status;
        }

      },
      loadDrivers() {
        KeplerBackofficeSdk.clients.list(1, 10000, {id: this.$route.params.id}).drivers((data) => {
          this.drivers = data.items
        })
      }
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-client-reservations
    .action-bar
      display: flex
      flex-flow: row nowrap
      justify-content: space-between
      align-items: center
      .action
        display: flex
        flex-flow: row
        align-items: center
        width: unset
        .entity-filters
          margin-right: 1em
          select
            height: 1.8em
</style>



// WEBPACK FOOTER //
// ClientReservations.vue?3515611c